exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7e26c222] h1{font-size:65px;font-family:SFPro;line-height:1.1;font-weight:700;color:#000}@media(max-width:600px){[data-v-7e26c222] h1{font-size:40px}}@media(max-width:480px){[data-v-7e26c222] h1{font-size:30px}}[data-v-7e26c222] h2,h3[data-v-7e26c222],h4[data-v-7e26c222]{font-family:SFProBold}[data-v-7e26c222] h2{font-size:28px}[data-v-7e26c222] h3{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e26c222","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/kbm/FreeRecoveriesInfo.vue
// module id = p5Re
// module chunks = 0